import moment from 'moment'

export const isMinor = (dateOfBirth: string) => {
    const diff = moment().diff(moment(dateOfBirth), 'years')
    if (diff >= 18) return false
    return true
}

export default { isMinor }